export const LOGGER_NAME = 'relay';

export const DEFAULT_CACHE_OPTIONS = {
  size: 250,
  ttl: 60 * 1000,
  clearOnMutation: true,
};
